import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ENCOUNTER_IDS } from "lib/encounter-ids.js";

export const specTypeIdx = 2;
export const classTypeIdx = 3;
export const pageIdx = 4;
export const encounterTypeIdx = 5;

export function getPathInfo(path) {
  const pathArr = path.split("?")[0].split("/");
  const classType = pathArr[classTypeIdx]?.toLowerCase() ?? "";
  const specType = pathArr[specTypeIdx]?.toLowerCase() ?? "";
  const page = pathArr[pageIdx]?.toLowerCase() ?? "";
  let encounterType = pathArr[encounterTypeIdx]?.toLowerCase() ?? "mythic";

  if (encounterType === "mythic+" || encounterType === "") {
    encounterType = "mythic";
  }

  return {
    encounterType,
    classType,
    specType,
    page,
    pathArr,
  };
}

export function updateWowPath(path, { classType = null, specType = null, page = null, encounterType = null }) {
  const { pathArr } = getPathInfo(path);
  const newPath = [...pathArr];
  if (classType) {
    newPath[classTypeIdx] = classType;
  }
  if (specType) {
    newPath[specTypeIdx] = specType;
  }
  if (page) {
    newPath[pageIdx] = page;
  }
  if (encounterType) {
    newPath[encounterTypeIdx] = encounterType;
  }

  return newPath.join("/");
}

export const getEncounterId = (optionalParams, encounterType) => {
  let encounterID = "all";

  let paramsMap = {};
  if (optionalParams.length > 1) {
    const params = optionalParams[1].split("&");
    for (let i = 0; i < params.length; i++) {
      const splitParams = params[i].split("=");
      paramsMap[splitParams[0]] = splitParams[1];
    }
  }

  if (paramsMap["encounter"]) {
    encounterID = ENCOUNTER_IDS[encounterType][paramsMap["encounter"]];
  }

  return encounterID;
};

export function useWowPath(pathname) {
  const location = useLocation();
  const history = useHistory();

  const { pathArr, ...pathInfo } = useMemo(() => {
    let path = pathname;
    if (!path) {
      path = location.pathname;
    }

    return getPathInfo(path);
  }, [pathname, location]);

  const changePage = useCallback(
    (page) => {
      const newPath = [...pathArr];
      newPath[pageIdx] = page;
      // When changing to the PvP page, need to remove the encounter type from the path
      if (page === "pvp") {
        newPath.splice(encounterTypeIdx, 1);
      }
      return newPath.join("/");
    },
    [pathArr],
  );

  const changeEncounter = useCallback(
    (type) => {
      const newPath = [...pathArr];
      newPath[encounterTypeIdx] = type;
      history.push({
        pathname: newPath.join("/"),
      });
    },
    [pathArr],
  );

  const optionalParams = location.search.split("?");

  return {
    ...pathInfo,
    changePage,
    changeEncounter,
    optionalParams,
  };
}
